import React from 'react';
import styled from 'styled-components';

const Styled = styled.div`

    label {
        display: inline;
    }

    label span {
        white-space: normal;
        display: inline-block;
    }       
    label span::first-letter {
        text-transform: capitalize;
    }    
`;


export interface InputLabelProps {
    htmlFor?: string;
    label?: string;
    required?: boolean;
    classnames?: string;
}

const InputLabel = ({
    htmlFor,
    label,
    required,
    classnames
}: InputLabelProps): JSX.Element => {
    return (
        <Styled>
            <label className={classnames} htmlFor={htmlFor || label}>
                <span>{label}&#8288;{required && '*'}&#8288;:</span>        
            </label>
        </Styled>
    );
};

export default InputLabel;
